﻿// Инлайн-правка поля формы просмотра (серверная часть — default_view_rep.InlineField).
// Корень режима правки содержит контрол редактора и кнопки *_submitedit / *_canceledit;
// контрол редактора (в т.ч. сложный, со своим data-ctrl) инициализируется сам.
// Enter — сохранить, Esc и клик вне поля — отменить.
class InlineFieldEditor extends Tango.Component {
	widgetDidMount() {
		this.detach();

		// Держим сам элемент, а не id: после перерисовки поля (в т.ч. в режим просмотра
		// с тем же id) старый корень отключается от документа и обработчики снимаются
		const root = document.getElementById(this.root);
		if (!root) return;

		const submitBtn = root.querySelector('[id$="_submitedit"]');
		const cancelBtn = root.querySelector('[id$="_canceledit"]');

		const inp = root.querySelector('input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled])');
		if (inp) {
			inp.focus();
			if (inp.type == 'text') inp.select();
		}

		const post = btn => {
			this.detach();
			if (btn) this.props.ajax.postEventFromElementWithApiResponse(btn);
		};

		// Слушаем документ, а не корень: у контролов без фокусируемого видимого элемента
		// (например, переключатель со скрытым checkbox) фокус остаётся на body
		this._keydown = e => {
			if (!root.isConnected) {
				this.detach();
				return;
			}
			// Клавишу уже обработал вложенный контрол
			if (e.defaultPrevented) return;
			// Фокус в другом месте (другое поле, модальный диалог) — клавиша не наша
			const active = document.activeElement;
			if (active && active !== document.body && !root.contains(active)) return;
			if (e.key == 'Escape') {
				e.preventDefault();
				post(cancelBtn);
			}
			else if (e.key == 'Enter' && e.target.tagName != 'TEXTAREA') {
				e.preventDefault();
				post(submitBtn);
			}
		};

		this._bodyClick = e => {
			// Редактор уже закрыт (поле перерисовано)
			if (!root.isConnected) {
				this.detach();
				return;
			}
			// Свои кнопки сохранения / отмены отправляют событие сами
			if ((submitBtn && submitBtn.contains(e.target)) || (cancelBtn && cancelBtn.contains(e.target))) {
				this.detach();
				return;
			}
			// Клик внутри редактора, по элементу, удалённому при перерисовке, или в модальном диалоге
			if (root.contains(e.target) || !document.body.contains(e.target) || e.target.closest('.modal-dialog'))
				return;
			post(cancelBtn);
		};

		document.addEventListener('keydown', this._keydown);
		document.body.addEventListener('click', this._bodyClick);
	}

	detach() {
		if (this._bodyClick) document.body.removeEventListener('click', this._bodyClick);
		if (this._keydown) document.removeEventListener('keydown', this._keydown);
		this._bodyClick = null;
		this._keydown = null;
	}
}

Tango.registerComponent(InlineFieldEditor, sp => ({ ajax: sp.ajaxUtils }));
